import { ActivatedRoute, Data, NavigationExtras, Route, Router, Routes } from '@angular/router';

export interface NavigationInfo {
  Commands: any[];
  Extras: NavigationExtras;
}

export class Routing {
  public static readonly ROUTE_DATA_MARKER_TAG_PROPERTY: string = 'MarkerTag';

  public static findRoute(routes: Routes, routePath: string, markerTag?: string): Route {
    return (
      routes.find((r) => Routing.isRouteMatch(r, routePath, markerTag)) ??
      routes.find((r) => Routing.isRouteMatch(r, routePath))
    );
  }

  private static isRouteMatch(route: Route, searchedRoutePath: string, searchedMarkerTag?: string): boolean {
    let isMatch: boolean = false;

    if (route.path === searchedRoutePath) {
      if (searchedMarkerTag) {
        if (route.data) {
          const actualMarkerTag: string = route.data[Routing.ROUTE_DATA_MARKER_TAG_PROPERTY] as string;

          if (actualMarkerTag === searchedMarkerTag) {
            isMatch = true;
          }
        }
      } else {
        isMatch = true;
      }
    }

    return isMatch;
  }

  public static createNavigationInfo(destinationRoute: Route, activatedRoute: ActivatedRoute, routeData?: Data) {
    // Search parent rout of destination
    let parentRoute: ActivatedRoute = Routing.findParentRouteForDestination(activatedRoute.root, destinationRoute);
    let otherOutletNames: string[] = []; // TODO?

    if (parentRoute) {
      otherOutletNames = parentRoute.children
        .map((ar) => ar.routeConfig)
        .filter((r) => r.outlet !== destinationRoute.outlet)
        .map((r) => r.outlet ?? 'primary')
        .filter((name, index, array) => array.indexOf(name) === index); // Make unique
    } else {
      parentRoute = activatedRoute.root;
    }

    const otherRoutesText: string = otherOutletNames.map((n) => `, "${n}": null`).join('');

    let naviCommands: any[];

    if (!destinationRoute.outlet || !destinationRoute.path || destinationRoute.outlet === 'primary') {
      naviCommands = [destinationRoute.path];
    } else {
      naviCommands = JSON.parse(
        `[{ "outlets": { "${destinationRoute.outlet}": "${destinationRoute.path}" ${otherRoutesText} }}]`
      );
    }

    let naviExtras: NavigationExtras = { relativeTo: parentRoute };

    if (routeData) {
      naviExtras.state = routeData;
    }

    return { Commands: naviCommands, Extras: naviExtras };
  }

  private static findParentRouteForDestination(
    activatedRoute: ActivatedRoute,
    destinationRoute: Route
  ): ActivatedRoute {
    let parentRoute: ActivatedRoute = null;

    if (activatedRoute.routeConfig?.children?.includes(destinationRoute)) {
      parentRoute = activatedRoute;
    } else {
      parentRoute = activatedRoute.children?.find((ar) => Routing.findParentRouteForDestination(ar, destinationRoute));
    }

    return parentRoute;
  }

  public static doesCurrentPageMatchRoute(router: Router, route: Route): boolean {
    if (route && route.path) {
      const currentUrl: string = router.routerState.snapshot.url;

      if (currentUrl) {
        if (route.outlet && route.outlet !== 'primary') {
          return currentUrl.endsWith(`/(${route.outlet}:${route.path})`);
        } else {
          return currentUrl?.endsWith(`/${route.path}`);
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
}
